import { FC, useEffect } from 'react';

import { datadogRum } from '@datadog/browser-rum';

import {
  useComplianceCourse,
  useComplianceTimer,
} from '@/utils/document-utils';

import GenericError from '@/components/Error/GenericError';

import { IframeView } from '../common';

import PageNotFound404 from '@/routes/404/404';

interface CompliancePlanProps {
  courseId: string;
}

/** View for compliance plans. */
const CompliancePlan: FC<CompliancePlanProps> = ({ courseId }) => {
  const { complianceUrl, error } = useComplianceCourse(courseId);
  const { startTimer, stopTimer } = useComplianceTimer(courseId);

  useEffect(() => {
    startTimer();
    return () => stopTimer();
  }, [startTimer, stopTimer]);

  if (error) {
    if ('status' in error && error.status === 404) {
      datadogRum.addError(error);
      return <PageNotFound404 />;
    } else {
      datadogRum.addError(error);
      return <GenericError />;
    }
  }

  return <IframeView isCompliance url={complianceUrl} />;
};

export default CompliancePlan;
